import { useContext } from 'react';

import { DeleteHabitContext } from './delete-habit-context';

export const useOpenDeleteHabitDialog = () => {
  const { onDeleteHabit } = useContext(DeleteHabitContext);

  return onDeleteHabit;
};
